//Important Notes Start

//Last updated: 26 October 2023
//Removed Delivery from addresses.


//Important Notes End


//Import Statements Start

import DialoguePopup from "../../helpers/DialoguePopup";
import React, { useState, useRef, useEffect, Fragment } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import cardsService from "../../services/cards.services";
import clientmanagmentObj from "../../services/client-managment.service";

import BoLoader from "../../helpers/BoLoader";
import moment from "moment";
import DateFormat from "../../helpers/DateFormat";
import { subYears } from "date-fns";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ReactDatePickerHelper from "../../helpers/ReactDatePickerHelper";
import { useSelector } from "react-redux";
import GetAllClients from "../../helpers/GetAllClients";
import RefreshToken from "../../helpers/RefreshToken";
import ReactFlagsSelect from "react-flags-select";
import { TrimCharacters } from "../../helpers/TrimCharacters";
import OccupationSelect from "./OccupationSelect";
import OccupationSelectOB from "./OccupationSelectOB";


//Import Statements End

//Validations Fields Input Start
const firstNameRequired = value => {
  if (!value) {
    document.getElementById("id_firstname").classList.add("has_error");
    return <span className="help-block">First Name is required!</span>;
  } else document.getElementById("id_firstname").classList.remove("has_error");
};
const firstNameLength = value => {
  if (value.length < 2) {
    document.getElementById("id_firstname").classList.add("has_error");
    return <span className="help-block">First Name must contain 2 characters!</span>;
  } else document.getElementById("id_firstname").classList.remove("has_error");
};
const lastNameRequired = value => {
  if (!value) {
    document.getElementById("id_lastname").classList.add("has_error");
    return <span className="help-block">Last Name is required!</span>;
  } else document.getElementById("id_lastname").classList.remove("has_error");
};
const lastNameLength = value => {
  if (value.length < 2) {
    document.getElementById("id_lastname").classList.add("has_error");
    return <span className="help-block">Last Name must contain 2 characters!</span>;
  } else document.getElementById("id_lastname").classList.remove("has_error");
};
const prefferedNameRequired = value => {
  if (!value) {
    document.getElementById("id_preferredname").classList.add("has_error");
    return <span className="help-block">Preferred Name is required!</span>;
  } else
    document.getElementById("id_preferredname").classList.remove("has_error");
};
const prefferedNameLength = value => {
  if (value.length < 2) {
    document.getElementById("id_preferredname").classList.add("has_error");
    return <span className="help-block">Preferred Name must contain 2 characters!</span>;
  } else
    document.getElementById("id_preferredname").classList.remove("has_error");
};
const deliveryAddressRequired = value => {
  if (!value) {
    document.getElementById("deliveryaddress").classList.add("has_error");
    return <span className="help-block"> Address is required!</span>;
  } else
    document.getElementById("deliveryaddress").classList.remove("has_error");
};
const deliveryAddresslength = value => {
  if (value.length < 8) {
    document.getElementById("deliveryaddress").classList.add("has_error");
    return <span className="help-block"> Address must contain 8 characters!</span>;
  } else
    document.getElementById("deliveryaddress").classList.remove("has_error");
};
const billingAddresslength = value => {
  if (value.length < 8) {
    document.getElementById("id_billingaddress").classList.add("has_error");
    return <span className="help-block">Billing Address must contain 8 characters!</span>;
  } else
    document.getElementById("id_billingaddress").classList.remove("has_error");
};
const deliveryCityRequired = value => {
  if (!value) {
    document.getElementById("id_deliverycity").classList.add("has_error");
    return <span className="help-block"> City is required!</span>;
  } else
    document.getElementById("id_deliverycity").classList.remove("has_error");
};
const deliveryCityLength = value => {
  if (value.length < 3) {
    document.getElementById("id_deliverycity").classList.add("has_error");
    return <span className="help-block"> City must contain 3 characters!</span>;
  } else
    document.getElementById("id_deliverycity").classList.remove("has_error");
};
const deliveryZipCodeRequired = value => {
  if (!value) {
    document.getElementById("id_deliveryzipcode").classList.add("has_error");
    return <span className="help-block"> Zip Code is required!</span>;
  } else
    document.getElementById("id_deliveryzipcode").classList.remove("has_error");
};
const deliveryZipCodeLength = value => {
  if (value.length < 3) {
    document.getElementById("id_deliveryzipcode").classList.add("has_error");
    return <span className="help-block"> Zip Code must contain 3 characters!</span>;
  } else
    document.getElementById("id_deliveryzipcode").classList.remove("has_error");
};
const billingAddressRequired = value => {
  if (!value) {
    document.getElementById("id_billingaddress").classList.add("has_error");
    return <span className="help-block">Billing Address is required!</span>;
  } else
    document.getElementById("id_billingaddress").classList.remove("has_error");
};
const billingCityRequired = value => {
  if (!value) {
    document.getElementById("id_billingcity").classList.add("has_error");
    return <span className="help-block">Billing City is required!</span>;
  } else
    document.getElementById("id_billingcity").classList.remove("has_error");
};
const billingCityLength = value => {
  if (value.length < 3) {
    document.getElementById("id_billingcity").classList.add("has_error");
    return <span className="help-block">Billing City must contain 3 characters!</span>;
  } else
    document.getElementById("id_billingcity").classList.remove("has_error");
};

const billingZipCodeRequired = value => {
  if (!value) {
    document.getElementById("billingzipcode").classList.add("has_error");
    return <span className="help-block">Billing Zip Code is required!</span>;
  } else
    document.getElementById("billingzipcode").classList.remove("has_error");
};
const billingZipCodeLength = value => {
  if (value.length < 3) {
    document.getElementById("billingzipcode").classList.add("has_error");
    return <span className="help-block">Billing Zip Code must contain 3 characters!</span>;
  } else
    document.getElementById("billingzipcode").classList.remove("has_error");
};
const billingStateRequired = value => {
  if (!value) {
    document.getElementById("billingstate").classList.add("has_error");
    return <span className="help-block">Billing State is required!</span>;
  } else
    document.getElementById("billingstate").classList.remove("has_error");
};
const billingStateLength = value => {
  if (value.length < 1) {
    document.getElementById("billingstate").classList.add("has_error");
    return <span className="help-block">Billing State must contain 2 characters!</span>;
  } else
    document.getElementById("billingstate").classList.remove("has_error");
};
const deliveryStateRequired = value => {
  if (!value) {
    document.getElementById("deliverystate").classList.add("has_error");
    return <span className="help-block"> State is required!</span>;
  } else
    document.getElementById("deliverystate").classList.remove("has_error");
};
const deliveryStateLength = value => {
  if (value.length < 1) {
    document.getElementById("deliverystate").classList.add("has_error");
    return <span className="help-block"> State must contain 2 characters!</span>;
  } else
    document.getElementById("deliverystate").classList.remove("has_error");
};
const Emailrequired = value => {
  if (!value) {
    document.getElementById("Email-frmgrp").classList.add("has_error");
    return <span className="help-block">Email is required!</span>;
  } else document.getElementById("Email-frmgrp").classList.remove("has_error");
};

const phonerequired = value => {
  if (!value) {
    document.getElementById("phone-frmgrp").classList.add("has_error");
    return <span className="help-block">Phone Number is required!</span>;
  } else document.getElementById("phone-frmgrp").classList.remove("has_error");
};
const validEmail = value => {
  if (!isEmail(value)) {
    document.getElementById("Email-frmgrp").classList.add("has_error");
    return <span className="help-block">Invalid Email!</span>;
  } else document.getElementById("Email-frmgrp").classList.remove("has_error");
};
const cardHolderProfessionRequired = value => {
  if (!value) {
    document.getElementById("card_holder_profession").classList.add("has_error");
    return <span className="help-block">Card Holder Profession is required!</span>;
  } else document.getElementById("card_holder_profession").classList.remove("has_error");
};

const cardHolderOccupationRequired = value => {
  if (!value) {
    document.getElementById("card_holder_occupation").classList.add("has_error");
    return <span className="help-block">Card Holder Occupation is required!</span>;
  } else document.getElementById("card_holder_occupation").classList.remove("has_error");
};

const cardHolderEmployerRequired = value => {
  if (!value) {
    document.getElementById("card_holder_employer_name").classList.add("has_error");
    return <span className="help-block">Card Holder Employment is required!</span>;
  } else document.getElementById("card_holder_employer_name").classList.remove("has_error");
};

// const spendingLimitMinimum = value => {
//   if (value && parseFloat(value) <= 10) {
//     document.getElementById("billingzipcode").classList.add("has_error");
//     return <span className="help-block">Spending Limit must be greater than 10!</span>;
//   } else {
//     document.getElementById("billingzipcode").classList.remove("has_error");
//   }
// };

// const vusername = (value) => {
//   if (value.length < 3 || value.length > 50) {
//     return (
//       <span className="help-block">
//         The username must be between 2 and 50 characters.
//       </span>
//     );
//   }
// };
//Validations Fields Input End
const IssueCardBody = props => {
  const { user: currentUser } = useSelector(state => state.auth);

  const [cardHolderDetailsAreaSelected, setCardHolderDetailsAreaSelected] =
    useState("true");
  const [cardDetailsAreaSelected, setCardDetailsAreaSelected] =
    useState("false");
  const [cardHolderDetailsClassName, setTcardHolderDetailsClassName] =
    useState("nav-link active");
  const [cardDetailsClassName, setTcardDetailsClassName] = useState("nav-link");
  const [cardHolderContentClassName, setCardHolderContentClassName] = useState(
    "tab-pane fade show active"
  );
  const [cardContentClassName, setCardContentClassName] =
    useState("tab-pane fade");
  const [modalShow, setModalShow] = React.useState(false);
  const form = useRef();
  const checkBtn = useRef();
  const [username, setUsername] = useState("");
  const [Name, setBoUserName] = useState("");
  // const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dob, setDob] = useState();
  const [Address, setAddress] = useState("");
  const [cardExpiry, setCardExpiry] = useState("");
  const [availableBalance, setAvailableBalance] = useState("");
  const [modelhdng, setMdlHdng] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");
  const [modelbdy, setMdlBdy] = useState("");
  const [DeliveryMode, setDeliveryMode] = useState('');
  const [disableBtns, setDisabledBtns] = useState(false);
  const [showDOBErr, setShowDOBErr] = useState("d-none");
  const [showPhoneErr, setshowPhoneErr] = useState("d-none");
  const [boloader, setBoLoader] = useState(false);
  const [ClientNameVal, setClientNameVal] = useState("");
  const [isValidPhoneNumber, setisValidPhoneNumber] = useState(true);
  //New Fields for Cardholder and Cards Nium
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [PreferredName, setPreferredName] = useState("");
  const [Gender, setGender] = useState("Male");
  const [Email, setEmail] = useState("");
  const [Mobile, setMobile] = useState("");
  const [phoneNumberWithCountryCode, setPhoneNumberWithCountryCode] = useState("");
  const [Nationality, setNationality] = useState("");
  const [DeliveryCountry, setDeliveryCountry] = useState("");
  const [BillingCountry, setBillingCountry] = useState("");

  const [CountryCode, setCountryCode] = useState("");
  const [PaymentProcessorClient, setPaymentProcessorClient] = useState("");
  const [DeliveryAddress1, setDeliveryAddress1] = useState("");
  const [DeliveryCity, setDeliveryCity] = useState("");
  const [DeliveryZipCode, setDeliveryZipCode] = useState("");
  const [BillingAddress1, setBillingAddress1] = useState("");
  const [BillingCity, setBillingCity] = useState("");
  const [BillingZipCode, setBillingZipCode] = useState("");
  const [cardFeeCurrencyCode, setcardFeeCurrencyCode] = useState();
  const [cardCurrency, setcardCurrency] = useState();
  const [cardType, setcardType] = useState("GPR_VIR");
  const [cardIssuanceAction, setcardIssuanceAction] = useState("NEW");
  const [showNationalityErr, setshowNationalityErr] = useState("d-none");
  const [showDeliveryCountryErr, setshowDeliveryCountryErr] =
    useState("d-none");
  const [showDeliveryModeErr, setshowDeliveryModeErr] =
    useState("d-none");
  const [showBillingCountryErr, setshowBillingCountryErr] = useState("d-none");
  //Mswipe Payment Processor
  const [PaymentProcessor, setPaymentProcessor] = useState(
    String(currentUser.user.PaymentProcessor)
  );
  const [showClientErr, setShowClientErr] = useState("d-none");
  //Issuer-B Spending Limits
  const [SpendingLimits, setSpendingLimits] = useState();
  const [showSpendingLimitErr, setShowSpendingLimitErr] = useState("d-none");
  const [spendingLimitErrMsg, setSpendingLimitErrMsg] = useState("Spending Limit is required!");
  //Issuer S or ISsuer B For m-Swipe
  const [IssuerCategory, setIssuerCategory] = useState();
  const [CardFlow, setCardFlow] = useState();
  const [BillingState, setBillingState] = useState("");
  const [DeliveryState, setDeliveryState] = useState("");
  const [CardColor, setCardColor] = useState("Green");
  const [showCardColorErr, setShowCardColorErr] =
    useState("d-none");
    const [OccupationCode, setOccupationCode] = useState("");
  const [CardVisaMaster, setCardVisaMaster] = useState("");
  const [IssuerBinId, setIssuerBinId] = useState("");
  const [CheckcardVisaMaster, setCheckCardVisaMaster] = useState("Select");
  const [showCardCategoryErr, setshowCardCategoryErr] = useState("d-none");
  const [last4DigitsOfCardNumber , setLast4DigitsOfCardNumber] = useState("");
  const [cardholderProfession  , setCardholderProfession] = useState("");
  const [cardholderOccupation  , setCardholderOccupation] = useState("");
  const [cardholderEmployername  , setCardholderEmployername] = useState("");
  const [cardProgram, setCardProgram] = useState("");
  const [showCardProgramErr, setShowCardProgramErr] = useState("d-none");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [showPlaceOfBirthErr, setShowPlaceOfBirthErr] = useState("d-none");
  //IssuerZD KYC Fields
  const [KycType, setKycType] = useState("PASSPORT");
  const [IdNumber, setIdNumber] = useState("");
  const [IdIssueDate, setIdIssueDate] = useState();
  const [IdExpDate, setIdExpDate] = useState();
  const [showKycTypeErr, setShowKycTypeErr] = useState("d-none");
  const [showIdNumberErr, setShowIdNumberErr] = useState("d-none");
  const [showIdIssueDateErr, setShowIdIssueDateErr] = useState("d-none");
  const [showIdExpDateErr, setShowIdExpDateErr] = useState("d-none");
  const [showOccupationErr, setShowOccupationErr] = useState("d-none");
  //Validations Dropdown Starts
  const requiredDob = value => {
    if (!value) {
      document.getElementById("dob-frmgrp").classList.add("has_error");
      setShowDOBErr("");
      return false;
    } else {
      document.getElementById("dob-frmgrp").classList.remove("has_error");
      setShowDOBErr("d-none");
      return true;
    }
  };
  const requiredPhoneNo = value => {
    if (phoneNumber.length < 3) setisValidPhoneNumber(false);
    else setisValidPhoneNumber(true);
    if (!value) {
      document.getElementById("phone-frmgrp").classList.add("has_error");
      setshowPhoneErr("");
      return false;
    } else {
      document.getElementById("phone-frmgrp").classList.remove("has_error");
      setshowPhoneErr("d-none");
      return true;
    }
  };
  const requiredNationality = value => {
    if (!value) {
      document.getElementById("id_nationality").classList.add("has_error");
      setshowNationalityErr("");
      return false;
    } else {
      document.getElementById("id_nationality").classList.remove("has_error");
      setshowNationalityErr("d-none");
      return true;
    }
  };
  const requiredPlaceOfBirth = value => {
    if (!value) {
      document.getElementById("id_placeofbirth").classList.add("has_error");
      setShowPlaceOfBirthErr("");
      return false;
    } else {
      document.getElementById("id_placeofbirth").classList.remove("has_error");
      setShowPlaceOfBirthErr("d-none");
      return true;
    }
  };
  const requiredDeliveryCountry = value => {
    if (!value) {
      document.getElementById("id_deliverycountry").classList.add("has_error");
      setshowDeliveryCountryErr("");
      return false;
    } else {
      document
        .getElementById("id_deliverycountry")
        .classList.remove("has_error");
      setshowDeliveryCountryErr("d-none");
      return true;
    }
  };
  // const requiredBillingCountry = value => {
  //   if (!value) {
  //     document.getElementById("id_billingcountry").classList.add("has_error");
  //     setshowBillingCountryErr("");
  //     return false;
  //   } else {
  //     document
  //       .getElementById("id_billingcountry")
  //       .classList.remove("has_error");
  //     setshowBillingCountryErr("d-none");
  //     return true;
  //   }
  // };
  //validation of Delivery mode
  const requiredDeliveryMode = value => {
    if (!value) {
      document.getElementById("delivery_mode").classList.add("has_error");
      setshowDeliveryModeErr("");
      return false;
    } else {
      document
        .getElementById("delivery_mode")
        .classList.remove("has_error");
      setshowDeliveryModeErr("d-none");
      return true;
    }
  };
  //IssuerZD Required Validators
  const requiredKycType = value => {
    if (IssuerCategory !== "IssuerZD") {
      setShowKycTypeErr("d-none");
      return true;
    }
    if (!value) {
      setShowKycTypeErr("");
      return false;
    }
    setShowKycTypeErr("d-none");
    return true;
  };
  const requiredIdNumber = value => {
    if (IssuerCategory !== "IssuerZD" ) {
      setShowIdNumberErr("d-none");
      return true;
    }
    if (!value) {
      setShowIdNumberErr("");
      return false;
    }
    setShowIdNumberErr("d-none");
    return true;
  };
  const requiredIdIssueDate = value => {
    if (IssuerCategory !== "IssuerZD") {
      setShowIdIssueDateErr("d-none");
      return true;
    }
    if (!value) {
      setShowIdIssueDateErr("");
      return false;
    }
    setShowIdIssueDateErr("d-none");
    return true;
  };
  const requiredIdExpDate = value => {
    if (IssuerCategory !== "IssuerZD") {
      setShowIdExpDateErr("d-none");
      return true;
    }
    if (!value) {
      setShowIdExpDateErr("");
      return false;
    }
    setShowIdExpDateErr("d-none");
    return true;
  };
  const requiredOccupationZD = value => {
    if (IssuerCategory !== "IssuerZD") {
      setShowOccupationErr("d-none");
      return true;
    }
    if (!value) {
      setShowOccupationErr("");
      return false;
    }
    setShowOccupationErr("d-none");
    return true;
  };
  //Validations Dropdown End
  const onChangeEmail = e => {
    const email = e.target.value;
    setEmail(email);
    setUsername(email);
  };
  const onChangeDOB = value => {
    let DOB = value;
    if (DOB) DOB = new Date(DOB);
    setDob(DOB);
    requiredDob(value);
  };
  
  const onChangePhoneNumberOB = (value, data)=> {
  const dialCode = data?.dialCode || "";
  let fullValue = value || "";
  setPhoneNumberWithCountryCode(fullValue);
  let localNumber = fullValue.replace(/\s+/g, "");
  if (dialCode && localNumber.startsWith(dialCode)) {
    localNumber = localNumber.substring(dialCode.length);
  }

  requiredPhoneNo(localNumber);
  setPhoneNumber(localNumber);
  setMobile(localNumber);
  };
 const onChangePhoneNumber = e => {
    requiredPhoneNo(e);
    setPhoneNumber(e);
    setMobile(e);
  }
  //UseEffects Start
  useEffect(() => {
    if (phoneNumber.length === 0) setisValidPhoneNumber(true);
    else if (phoneNumber.length < 3) setisValidPhoneNumber(false);
    else setisValidPhoneNumber(true);
  }, [phoneNumber]);
  useEffect(() => {
    setCountryCode(Nationality);
  }, [Nationality]);

  //UseEffects End
  //API Call Start
  const IssueCardHolderHandler = e => {
    if (e) e.preventDefault();
    form.current.validateAll();
    let dobValid = requiredDob(dob);
    let phoneValid = requiredPhoneNo(phoneNumber);
    let nationality = requiredNationality(Nationality);
    let deliverycountry = requiredDeliveryCountry(DeliveryCountry);
    // let billingcountry = requiredBillingCountry(BillingCountry);
    let checkclient = requiredClient(ClientNameVal);
    let checkcardcategory = requiredCardCategory(CardVisaMaster);

    // Check place of birth for Issuer11 and Issuer12
    let checkplaceofbirth = true;
    if (IssuerCategory === "IssuerOB" || IssuerCategory === "Issuer11" || IssuerCategory === "Issuer12"||props?.issuerCategory === "OB-OF"||props?.issuerCategory === "OB-OF" ||IssuerCategory === "OB-TIX"||IssuerCategory === "OB-FIT") {
      checkplaceofbirth = requiredPlaceOfBirth(placeOfBirth);
    }

    // Determine the actual card program value based on IssuerCategory
    let actualCardProgram = cardProgram;
    if (IssuerCategory === "Issuer11") {
      actualCardProgram = "11";
    } else if (IssuerCategory === "Issuer12") {
      actualCardProgram = "12";
    }

    let checkcardprogram = requiredCardProgram(actualCardProgram);
    let checkspendinglimit = requiredSpendingLimit(SpendingLimits);

    // IssuerZD KYC fields validation
    let checkkyctype = requiredKycType(KycType);
    let checkidnumber = requiredIdNumber(IdNumber);
    let checkidissuedate = requiredIdIssueDate(IdIssueDate);
    let checkidexpdate = requiredIdExpDate(IdExpDate);
    let checkoccupationzd = requiredOccupationZD(OccupationCode);

    const DateOfBirthStr = dob ? moment(dob).format("YYYY-MM-DD") : "";
    const IdIssueDateStr = IdIssueDate ? moment(IdIssueDate).format("YYYY-MM-DD") : "";
    const IdExpDateStr = IdExpDate ? moment(IdExpDate).format("YYYY-MM-DD") : "";
if(IssuerCategory=="IssuerM" || IssuerCategory=="IssuerX"){
  if (!IssuerBinId) {
  errorAndSuccessModl("Error", "Please select a valid BIN ID", "icon-error");
  return;
}
}
      if (
        checkBtn.current.context._errors.length === 0 &&
        dobValid &&
        phoneValid &&
        nationality &&
        deliverycountry &&
       checkclient && checkcardcategory && checkcardprogram && checkplaceofbirth && checkspendinglimit &&
       checkkyctype && checkidnumber && checkidissuedate && checkidexpdate && checkoccupationzd
      ) {
        setBoLoader(true);
        cardsService
          .IssueCardToCardHolder(
            FirstName,
            LastName,
            PreferredName,
            Gender,
            DateOfBirthStr,
            Email,
            Mobile,
            Nationality,
            DeliveryAddress1,
            DeliveryCity,
            DeliveryZipCode,
            BillingAddress1,
            BillingCity,
            BillingZipCode,
            cardFeeCurrencyCode,
            cardType,
            CountryCode,
            cardIssuanceAction,
            BillingCountry,
            DeliveryCountry,
            DeliveryMode || '',
            Number(ClientNameVal) || Number(currentUser.user.ClientId),
             SpendingLimits, BillingState, DeliveryState, CardColor, CardVisaMaster,OccupationCode,
            (IssuerCategory === "IssuerZD")
              ? IdIssueDateStr
              : ((IssuerCategory === "IssuerOB" || IssuerCategory === "Issuer11" || IssuerCategory === "Issuer12"||
                props?.issuerCategory === "OB-OF" ||IssuerCategory === "OB-OF"
                ||IssuerCategory === "OB-TIX"||IssuerCategory === "OB-FIT")
                  ? String(placeOfBirth)
                  : String(cardholderProfession)),
            (IssuerCategory === "IssuerZD") ? IdExpDateStr : String(cardholderOccupation),
            (IssuerCategory === "IssuerZD") ? KycType : String(cardholderEmployername),
            Number(IssuerBinId),
            (IssuerCategory === "IssuerZD" ) ? IdNumber : actualCardProgram
          )
          .then(cardData => {
            setBoLoader(false);
            if (cardData && cardData.data && cardData.data.success) {
              setCardHolderDetailsAreaSelected("false");
              setCardDetailsAreaSelected("true");
              setTcardHolderDetailsClassName("nav-link");
              setTcardDetailsClassName("nav-link active");
              setCardHolderContentClassName("tab-pane fade");
              setCardContentClassName("tab-pane fade show active");
            }
          })
          .catch(err => {
            setBoLoader(false);
            let msgBody =
              err && err.response && err.response.data
                ? err.response.data.message
                : "Something went wrong please contact support !";
            let errIcon = "icon-error";
            errorAndSuccessModl("Error", msgBody, errIcon);
            (async () => {
              setBoLoader(true);
              let resp = await RefreshToken(
                err && err.response && err.response.status
              );
              if (resp) {
                IssueCardHolderHandler();
                setBoLoader(false);
              } else {
                setBoLoader(false);
              }
            })();
          });
      }
    
  };
  //API Call End
  const errorAndSuccessModl = (heading, body, Icon) => {
    setModalShow(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(Icon);
  };
  const IssueCardDoneHandler = e => {
    e.preventDefault();
    // setDisabledBtns(true);
    props.onHide();
  };
  const ClientNameChangeHandler = async e => {
   
    const clientName = e.target.selectedOptions[0].value;
     setBoLoader(true);
    await clientmanagmentObj
      .getprofiledetails(String(clientName))
      .then((response) => {
         setBoLoader(false);
        setPaymentProcessorClient(response?.data?.payload?.result?.paymentProcesor)
      }).catch(()=>{
         setBoLoader(false);
      })
    const paymentProcessor =
      e?.target?.selectedOptions[0]?.attributes[1]?.nodeValue ?? "EUR";
    const currency = e?.target?.selectedOptions[0]?.attributes[0]?.nodeValue ?? "-";
    requiredClient(clientName);
    const issuercat = e?.target?.selectedOptions[0]?.attributes[4]?.nodeValue;
    const cardflow = e?.target?.selectedOptions[0]?.attributes[3]?.nodeValue;
    const checkVisaMaster = e?.target?.selectedOptions[0]?.attributes[5]?.nodeValue;

    setClientNameVal(clientName);
    setcardFeeCurrencyCode(currency);
    setcardCurrency(currency);
    setIssuerCategory(issuercat);
    setCardFlow(cardflow);
    setCheckCardVisaMaster(checkVisaMaster);
    setIssuerBinId("");
  };

  const requiredClient = value => {
    if (!value) {
      document.getElementById("id_client").classList.add("has_error");
      setShowClientErr("");
      return false;
    } else {
      document.getElementById("id_client").classList.remove("has_error");
      setShowClientErr("d-none");
      return true;
    }
  };
  const requiredCardCategory = value => {
    if (CheckcardVisaMaster === "Both") {
      if (value === "Select") {
        document.getElementById("id_cardType").classList.add("has_error");
        setshowCardCategoryErr("");
        return false;
      } else {
        document.getElementById("id_cardType").classList.remove("has_error");
        setshowCardCategoryErr("d-none");
        return true;
      }
    }
    else {
      return true
    }

  };
  const requiredSpendingLimit = value => {
    const el = document.getElementById("spendinglimit_issuer12");
    if (IssuerCategory !== "Issuer12" && IssuerCategory !== "IssuerCap-NKT" && IssuerCategory !== "IssuerZD"
       && IssuerCategory !== "IssuerCap-HK" && IssuerCategory !== "IssuerCap-HKT" &&IssuerCategory !== "OB-TIX"
       &&IssuerCategory !== "OB-FIT" &&IssuerCategory !== "OB-OF"
    ) {
      if (el) el.classList.remove("has_error");
      setShowSpendingLimitErr("d-none");
      return true;
    }
    if (value === undefined || value === null || value === "" || isNaN(value)) {
      if (el) el.classList.add("has_error");
      setSpendingLimitErrMsg("Spending Limit is required!");
      setShowSpendingLimitErr("");
      return false;
    }
    if ((IssuerCategory == "Issuer12" ||IssuerCategory == "OB-OF") && parseFloat(value) < 20) {
      if (el) el.classList.add("has_error");
      setSpendingLimitErrMsg("Spending Limit must be at least 20!");
      setShowSpendingLimitErr("");
      return false;
    }
     if (IssuerCategory == "OB-TIX" && parseFloat(value) < 1) {
      if (el) el.classList.add("has_error");
      setSpendingLimitErrMsg("Spending Limit must be at least 1!");
      setShowSpendingLimitErr("");
      return false;
    }
    if (IssuerCategory == "OB-FIT" && parseFloat(value) < 1) {
      if (el) el.classList.add("has_error");
      setSpendingLimitErrMsg("Spending Limit must be at least 1!");
      setShowSpendingLimitErr("");
      return false;
    }
     if ((IssuerCategory == "IssuerCap-HK" || IssuerCategory == "IssuerCap-HKT") 
      && parseFloat(value) < 5) {
      if (el) el.classList.add("has_error");
      setSpendingLimitErrMsg("Spending Limit must be at least 5!");
      setShowSpendingLimitErr("");
      return false;
    }
    if ((IssuerCategory == "IssuerCap-NKT" ) 
      && parseFloat(value) < 25) {
      if (el) el.classList.add("has_error");
      setSpendingLimitErrMsg("Spending Limit must be at least 25!");
      setShowSpendingLimitErr("");
      return false;
    }
    if ((IssuerCategory == "IssuerZD") && parseFloat(value) < 1) {
      if (el) el.classList.add("has_error");
      setSpendingLimitErrMsg("Spending Limit must be at least 1!");
      setShowSpendingLimitErr("");
      return false;
    }
    if (el) el.classList.remove("has_error");
    setShowSpendingLimitErr("d-none");
    return true;
  };
  const requiredCardProgram = value => {
    if (IssuerCategory === "IssuerOB") {
      if (!value) {
        document.getElementById("id_cardProgram").classList.add("has_error");
        setShowCardProgramErr("");
        return false;
      } else {
        document.getElementById("id_cardProgram").classList.remove("has_error");
        setShowCardProgramErr("d-none");
        return true;
      }
    }
    else if (IssuerCategory === "Issuer11"){
      // For Issuer11, the value will be set in IssueCardHolderHandler
      return true;
    }
      else if (IssuerCategory === "Issuer12" || IssuerCategory === "OB-OF"){
      // For Issuer12, the value will be set in IssueCardHolderHandler
      return true;
    }
    else {
      return true;
    }
  };
  const onChangeLast4DigitsOfCardNumber = (e) => {
    const number = e.target.value;
    if (number != "") {
      let value=number;
      setLast4DigitsOfCardNumber(value);
    }

  };

  const onChangeCardholderProfession = (e) => {
    const value = e?.target?.value;
    setCardholderProfession(value);
  };

  const onChangeCardholderOccupation = (e) => {
    const value = e?.target?.value;
    setCardholderOccupation(value);
  };

  const onChangeCardholderEmployername = (e) => {
    const value = e?.target?.value;
    setCardholderEmployername(value);
  };

  const onChangeFirstName = e => {
    let value = e.target.value;
    value = value.replace(/[^a-z0-9 ]/gi, '')
    setFirstName(value);
    if(IssuerCategory=="IssuerM" || IssuerCategory=="IssuerZD"){
        setPreferredName(value);
        prefferedNameLength(value);
        prefferedNameRequired(value);
    }
  };
  const onChangeLastName = e => {
    let value = e.target.value;
    value = value.replace(/[^a-z0-9 ]/gi, '')
    setLastName(value);
  };
  const onChangePreferredName = e => {
    let value = e.target.value;
    value = value.replace(/[^a-z0-9 ]/gi, '')
    setPreferredName(value);
  };
  const onChangeGender = e => {
    const name = e.target.value;
    setGender(name);
  };
  const onChangeDeliveryAddress = e => {
    const name = e.target.value;
    setDeliveryAddress1(name);
    setBillingAddress1(name);
  };
  const onChangeDeliveryCity = e => {
    let value = e.target.value;
    value = value.replace(/[^A-Za-z ]/ig, '')
    setDeliveryCity(value);
    setBillingCity(value);
  };
  const onChangeDeliveryZipCode = e => {
    let value = e.target.value;
    value = value.replace(/[^a-z0-9 ]/gi, '')
    setDeliveryZipCode(value);
    setBillingZipCode(value);
  };
  const onChangeDeliveryState = e => {
    let value = e.target.value;
    value = value.replace(/[^a-z0-9 ]/gi, '')
    setDeliveryState(value);
    setBillingState(value);
  };
  // const onChangeBillingAddress = e => {
  //   const name = e.target.value;
  //   setBillingAddress1(name);
  // };
  // const onChangeBillingCity = e => {
  //   let value = e.target.value;
  //   value = value.replace(/[^A-Za-z ]/ig, '')
  //   setBillingCity(value);
  // };
  // const onChangeBillingZipCode = e => {
  //   let value = e.target.value;
  //   value = value.replace(/[^a-z0-9 ]/gi, '')
  //   setBillingZipCode(value);
  // };
  // const onChangeBillingState = e => {
  //   let value = e.target.value;
  //   value = value.replace(/[^a-z0-9 ]/gi, '')
  //   setBillingState(value);
  // };
  const onChangeDeliveryMode = e => {
    const name = e.target.value;
    setDeliveryMode(name);
  };
  const toggleSameAsAbove = (e) => {
    const chckSame = e.target.checked;
    if (chckSame) {
      setBillingAddress1(DeliveryAddress1);
      setBillingCountry(DeliveryCountry);
      setBillingCity(DeliveryCity);
      setBillingZipCode(DeliveryZipCode);
    }
    else {
      setBillingAddress1("");
      setBillingCountry();
      setBillingCity("");
      setBillingZipCode("");
    }
  };
  const onChangeSpendingLimit = e => {
    let limit = e.target.value;
    if (limit !== "") {
      let value = parseFloat(limit);
      setSpendingLimits(value);
      requiredSpendingLimit(value);
    } else {
      setSpendingLimits(undefined);
      requiredSpendingLimit(undefined);
    }
  };
  const onChangeCardColor = e => {
    const name = e.target.value;
    setCardColor(name);
  };
  const onChangeCardVisaMaster = (e) => {
    const name = e?.target?.selectedOptions[0]?.value;
    setCardVisaMaster(name);
    requiredCardCategory(name);
    setIssuerBinId("");
  }
   const onChangeCardBin = (e) => {
    const name = e?.target?.selectedOptions[0]?.value;
    setIssuerBinId(name);
  }
  const onChangeSpendingLimitM = (e) => {
    const name = e?.target?.selectedOptions[0]?.value;
    if(name!=""){
      let val =parseFloat(name);
      setSpendingLimits(val);

    }
  }
  const onOccupationChange = (value) => {
    setOccupationCode(value);
    requiredOccupationZD(value);
  };
  const onChangeCardProgram = (e) => {
    const value = e?.target?.value;
    setCardProgram(value);
    requiredCardProgram(value);
  };
  const onChangeKycType = (e) => {
    const value = e?.target?.value;
    setKycType(value);
    requiredKycType(value);
  };
  const onChangeIdNumber = (e) => {
    const value = e?.target?.value;
    setIdNumber(value);
    requiredIdNumber(value);
  };
  const onChangeIdIssueDate = (value) => {
    let d = value;
    if (d) d = new Date(d);
    setIdIssueDate(d);
    requiredIdIssueDate(value);
  };
  const onChangeIdExpDate = (value) => {
    let d = value;
    if (d) d = new Date(d);
    setIdExpDate(d);
    requiredIdExpDate(value);
  };
  return (
    <Fragment>
      <div className="row">
        <BoLoader loading={boloader} />
        <div className="col-md-12">
          <h2>Issue Card</h2>
          <div className="mt-16">
            <div className="row">
              <div className="col-md-12">
                <div className="bo-tabs-mbl">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={cardHolderDetailsClassName} //""
                        id="cardHolder-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#cardHolder"
                        type="button"
                        role="tab"
                        aria-controls="cardHolder"
                        aria-selected={cardHolderDetailsAreaSelected}
                      >
                        Cardholder Details
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={cardDetailsClassName}
                        id="cardDetails-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#cardDetails"
                        type="button"
                        role="tab"
                        aria-controls="cardDetails"
                        aria-selected={cardDetailsAreaSelected}
                      >
                        Card Details
                      </button>
                    </li>
                  </ul>
                </div>

                <div className="tab-content" id="myTabContent">
                  <div
                    className={cardHolderContentClassName}
                    id="cardHolder"
                    role="tabpanel"
                    aria-labelledby="cardHolder-tab"
                  >
                    <div>
                      <h3>Enter cardholder details</h3>
                      <Form onSubmit={(e) => { e.preventDefault() }} ref={form}>
                        <div className="row mt-16">
                          <div className="col-md-6" id="id_client">
                            <div className="form-group">
                              <label>Select Client Ledger</label>
                              <div className="form-controls">
                                <GetAllClients
                                  clientnamechangehandler={
                                    ClientNameChangeHandler
                                  }
                                  searchgriddata="Y"
                                />
                                <span
                                  className={
                                    "help-block " + showClientErr
                                  }
                                >
                                  Client is required!
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6"></div>
                          <div className="col-md-6">
                            <div className="form-group" id="id_firstname">
                              <label>First Name*</label>
                              <div className="form-controls">
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="cardholderName"
                                  value={FirstName}
                                  onChange={onChangeFirstName}
                                  onKeyDown={(evt) => {
                                    let chck = TrimCharacters.checkSpecialCharacters(evt.key)
                                    if (chck)
                                      evt.preventDefault();
                                  }
                                  }
                                  validations={[firstNameRequired, firstNameLength]}
                                  maxLength="20"
                                />
                                <span className="icon-user _ico"></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group" id="id_lastname">
                              <label>Last Name*</label>
                              <div className="form-controls">
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="LastName"
                                  value={LastName}
                                  onChange={onChangeLastName}
                                  onKeyDown={(evt) => {
                                    let chck = TrimCharacters.checkSpecialCharacters(evt.key)
                                    if (chck)
                                      evt.preventDefault();
                                  }
                                  }
                                  validations={[lastNameRequired, lastNameLength]}
                                  maxLength="20"
                                />
                                <span className="icon-user _ico"></span>
                              </div>
                            </div>
                          </div>
                          {
                            (IssuerCategory!="IssuerM" && IssuerCategory!="IssuerZD") ?(
                               <div className="col-md-6">
                            <div className="form-group" id="id_preferredname">
                              <label>Preferred Name*</label>
                              <div className="form-controls">
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="PreferredName"
                                  value={PreferredName}
                                  onChange={onChangePreferredName}
                                  onKeyDown={(evt) => {
                                    let chck = TrimCharacters.checkSpecialCharacters(evt.key)
                                    if (chck)
                                      evt.preventDefault();
                                  }
                                  }
                                  validations={[prefferedNameRequired, prefferedNameLength]}
                                  maxLength="20"
                                />
                                <span className="icon-user _ico"></span>
                              </div>
                            </div>
                          </div>
                            ):(<div  id="id_preferredname"> </div>)
                          }
                         
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Gender*</label>
                              <div className="form-controls">
                                <select
                                  className="form-control no-icon"
                                  onChange={onChangeGender}
                                >
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3" id="dob-frmgrp">
                              <label>Date Of Birth* </label>
                              <div className="form-controls">
                                <ReactDatePickerHelper
                                  datevalue={dob}
                                  onchangedate={onChangeDOB}
                                  maximumdate={subYears(new Date(), 18)}
                                />
                                <span className="icon-calender _ico"></span>
                                <span className="icon-round icon-calender-mini"></span>
                                <span className="fs-12 clr-submarine mt-2 d-block">
                                  Age should be greater than 18 years
                                </span>
                                {/* <span className="icon-round icon-calender-mini"></span> */}
                                <span className={"help-block " + showDOBErr}>
                                  DOB is required!
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group" id="Email-frmgrp">
                              <label>Email*</label>
                              <div className="form-controls">
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="email"
                                  value={Email}
                                  onChange={onChangeEmail}
                                  validations={[Emailrequired, validEmail]}
                                  maxLength="50"
                                />
                                <span className="icon-email _ico"></span>
                              </div>
                            </div>
                          </div>
                         
                          {
                            (IssuerCategory=="IssuerOB" || IssuerCategory=="Issuer11" ||IssuerCategory=="Issuer12"
                              ||IssuerCategory=="OB-OF"
                              ||IssuerCategory === "OB-TIX"||IssuerCategory === "OB-FIT"
                            ) ?(<>
                             <div className="col-md-6">
                            <div className="form-group" id="phone-frmgrp">
                              <label>Phone Number*</label>
                              <div className="form-controls">
                                <PhoneInput
                                  class="form-control "
                                  country={"us"}
                                  onChange={onChangePhoneNumberOB}
                                  value={phoneNumberWithCountryCode}
                                  validations={phonerequired}
                                />
                                <span className={"help-block " + showPhoneErr}>
                                  Phone No is required!
                                </span>
                                {!isValidPhoneNumber && (
                                  <span className="help-block has_error">
                                    Minimum three number are required!
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                            </>):(<>
                             <div className="col-md-6">
                            <div className="form-group" id="phone-frmgrp">
                              <label>Phone Number*</label>
                              <div className="form-controls">
                                <PhoneInput
                                  class="form-control "
                                  country={"us"}
                                  onChange={onChangePhoneNumber}
                                  value={phoneNumber}
                                  validations={phonerequired}
                                />
                                <span className={"help-block " + showPhoneErr}>
                                  Phone No is required!
                                </span>
                                {!isValidPhoneNumber && (
                                  <span className="help-block has_error">
                                    Minimum three number are required!
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                            
                            </>)
                          }
                          {
                            IssuerCategory !="IssuerM" ?(
                              <div className="col-md-6">
                            <div className="form-group" id="id_nationality">
                              <label>Nationality*</label>
                              <div className="form-controls">
                                <ReactFlagsSelect

                                  className="form-control no-icon"
                                  selected={Nationality}
                                  onSelect={code => {
                                    setNationality(code);
                                    requiredNationality(code);
                                  }}
                                  searchable={true}
                                />
                                <span
                                  className={"help-block " + showNationalityErr}
                                >
                                  Nationality is required!
                                </span>
                              </div>
                            </div>
                          </div>
                            ):(<div id="id_nationality"></div>)
                          }
                          

                          <div className="col-md-6" id="deliveryaddress">
                            <div className="form-group" >
                              <label>Address*</label>
                              <div className="form-controls">
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="deliveryaddress"
                                  value={DeliveryAddress1}
                                  onChange={onChangeDeliveryAddress}
                                  validations={[deliveryAddressRequired, deliveryAddresslength]}
                                  maxLength="40"
                                />
                                <span className="icon-home _ico"></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group" id="id_deliverycountry">
                              <label>Country*</label>
                              <div className="form-controls">
                                <ReactFlagsSelect
                                  className="form-control no-icon"
                                  selected={DeliveryCountry}
                                  onSelect={code => {
                                    setDeliveryCountry(code);
                                    setBillingCountry(code);
                                    setDeliveryState(code);
                                    requiredDeliveryCountry(code);
                                    setNationality(code);
                                    requiredNationality(code);
                                  }}
                                  searchable={true}
                                />
                                <span
                                  className={
                                    "help-block " + showDeliveryCountryErr
                                  }
                                >
                                  Delivery Country is required!
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group" id="id_deliverycity">
                              <label>City*</label>
                              <div className="form-controls">
                                <Input
                                  type="text"
                                  className="form-control no-icon"
                                  name="address"
                                  value={DeliveryCity}
                                  onChange={onChangeDeliveryCity}
                                  onKeyDown={(evt) => {
                                    let chck = TrimCharacters.checkAlpha(evt.key)
                                    if (chck)
                                      evt.preventDefault();
                                  }
                                  }
                                  validations={[deliveryCityRequired, deliveryCityLength]}
                                  maxLength="20"
                                />
                              </div>
                            </div>
                          </div>
                          {
                            (IssuerCategory=="IssuerOB" || IssuerCategory=="Issuer11" ||IssuerCategory=="Issuer12"
                              ||IssuerCategory === "OB-TIX"||IssuerCategory === "OB-FIT"||IssuerCategory=="OB-OF"
                            ) &&(
                              <Fragment>
                                     <div className="col-md-6">
                                        <div className="form-group" id="id_placeofbirth">
                                          <label>Place of Birth*</label>
                                          <div className="form-controls">
                                            <ReactFlagsSelect
                                              className="form-control no-icon"
                                              selected={placeOfBirth}
                                              onSelect={code => {
                                                setPlaceOfBirth(code);
                                                requiredPlaceOfBirth(code);
                                              }}
                                              searchable={true}
                                            />
                                            <span
                                              className={"help-block " + showPlaceOfBirthErr}
                                            >
                                              Place of Birth is required!
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                       <div className="col-md-6" id="occupation-select">
                                <div className="form-group">
                                  <label>Occupation*</label>
                                  <div className="form-controls">
                                    <OccupationSelectOB
                                      selectedValue={OccupationCode}
                                      onChange={onOccupationChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              </Fragment>
                            )
                          }
                          <div className="col-md-6">
                            <div className="form-group" id="id_deliveryzipcode">
                              <label>ZIP Code*</label>
                              <div className="form-controls">
                                <Input
                                  type="text"
                                  className="form-control no-icon"
                                  name="address"
                                  value={DeliveryZipCode}
                                  onChange={onChangeDeliveryZipCode}
                                  onKeyDown={(evt) => {
                                    let chck = TrimCharacters.checkSpecialCharacters(evt.key)
                                    if (chck)
                                      evt.preventDefault();
                                  }
                                  }
                                  validations={[deliveryZipCodeRequired, deliveryZipCodeLength]}
                                  maxLength="10"
                                />
                              </div>
                            </div>
                          </div>
                          
                          {(IssuerCategory === "IssuerTGV" ||IssuerCategory === "IssuerM" ||IssuerCategory === "IssuerER"
                            || IssuerCategory === "IssuerOB" || IssuerCategory === "Issuer11" || IssuerCategory === "Issuer12"
                            ||IssuerCategory === "OB-TIX"||IssuerCategory === "OB-FIT"||IssuerCategory=="OB-OF"
                          ) ? (
                            <Fragment>
                              
                              <div className="col-md-6" id="deliverystate">
                                <div className="form-group" >
                                  { IssuerCategory === "IssuerTGV" ||IssuerCategory === "IssuerER"||
                                   IssuerCategory === "IssuerM" || IssuerCategory === "IssuerOB" || IssuerCategory === "Issuer11" || IssuerCategory === "Issuer12"
                                   ||IssuerCategory === "OB-TIX"||IssuerCategory === "OB-FIT"||IssuerCategory=="OB-OF"
                                   ? (<label> State(ISO 2 Digit)*</label>) : (
                                    <label>State/County *</label>
                                  )}

                                  <div className="form-controls">
                                    <Input
                                      type="text"
                                      className="form-control no-icon"
                                      name="DeliveryState"
                                      value={DeliveryState}
                                      onChange={onChangeDeliveryState}
                                      onKeyDown={(evt) => {
                                        let chck = TrimCharacters.checkSpecialCharacters(evt.key)
                                        if (chck)
                                          evt.preventDefault();
                                      }
                                      }
                                      validations={[deliveryStateRequired, deliveryStateLength]}
                                      maxLength={IssuerCategory === "IssuerTGV" ||IssuerCategory === "IssuerER" ? "2" : "30"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Fragment>
                          ) : (<><div id="billingstate">
                            </div> <div id="deliverystate"></div>
                            </>)}
                          {
                            (( IssuerCategory === "IssuerCap-HK"||IssuerCategory === "IssuerCap-HKT"))
                             && (
                              <div className="col-md-6" id="spendinglimit_issuer12">
                                <div className="form-group" >
                                  <label>Initial Load (min $5)*</label>
                                  <div className="form-controls">
                                    <Input
                                      type="number"
                                      className="form-control no-icon"
                                      name="spendinglimit"
                                      value={SpendingLimits}
                                      onChange={onChangeSpendingLimit}
                                      maxLength="10"
                                      min="5"
                                    />
                                    
                                    <span className={"help-block " + showSpendingLimitErr}>
                                      {spendingLimitErrMsg}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                           {
                            ((IssuerCategory == "IssuerCap-NKT"))
                             && (
                              <div className="col-md-6" id="spendinglimit_issuer12">
                                <div className="form-group" >
                                  <label>Initial Load (min $25)*</label>
                                  <div className="form-controls">
                                    <Input
                                      type="number"
                                      className="form-control no-icon"
                                      name="spendinglimit"
                                      value={SpendingLimits}
                                      onChange={onChangeSpendingLimit}
                                      maxLength="10"
                                      min="5"
                                    />
                                    
                                    <span className={"help-block " + showSpendingLimitErr}>
                                      {spendingLimitErrMsg}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                         {
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Card Fee Currency Code*</label>
                              <div className="form-controls">
                                <select
                                  className="form-control no-icon"
                                //onChange={onChangeCardFeeCurrencyCode}
                                >
                                  <option
                                    select="selected"
                                    value={cardCurrency}
                                  >
                                    {cardCurrency}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          }
                          {(IssuerCategory=="IssuerOB") && (
                            <div className="col-md-6" id="id_cardProgram">
                              <div className="form-group">
                                <label>Card Program*</label>
                                <div className="form-controls">
                                  <select
                                    className="form-control no-icon"
                                    onChange={onChangeCardProgram}
                                    value={cardProgram}
                                  >
                                    <option value="">Select</option>
                                    <option value="10">Apple Pay</option>
                                    <option value="9">Google Pay</option>
                                  </select>
                                  <span
                                    className={
                                      "help-block " + showCardProgramErr
                                    }
                                  >
                                    Card Program is required!
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                          {(IssuerCategory=="IssuerCap-NKT") && (
                            <div className="col-md-6" id="id_cardProgram">
                              <div className="form-group">
                                <label>Card Bin*</label>
                                <div className="form-controls">
                                  <select
                                    className="form-control no-icon"
                                    onChange={onChangeCardProgram}
                                    value={cardProgram}
                                  >
                                    <option value="">Select</option>
                                    <option value="P00PD20251024007073"> 49372434 (Visa)</option>
                                    <option value="P00PD20260302009335"> 49372410 (Visa)</option>
                                    <option value="P00PD20260921014997"> 556736 (Master)</option>

                                  </select>
                                  <span
                                    className={
                                      "help-block " + showCardProgramErr
                                    }
                                  >
                                    Card Program is required!
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                          
                          
                          {
                            (IssuerCategory === "IssuerZ" || IssuerCategory === "IssuerZD") && (
                              <div className="col-md-6" id="occupation-select">
                                <div className="form-group">
                                  <label>Occupation*</label>
                                  <div className="form-controls">
                                    <OccupationSelect
                                      selectedValue={OccupationCode}
                                      onChange={onOccupationChange}
                                    />
                                    <span className={"help-block " + showOccupationErr}>
                                      Occupation is required!
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          {
                            (IssuerCategory === "IssuerZD" ) && (
                              <Fragment>
                                <div className="col-md-6" id="id_kycType">
                                  <div className="form-group">
                                    <label>KYC Type*</label>
                                    <div className="form-controls">
                                      <select
                                        className="form-control no-icon"
                                        value={KycType}
                                        onChange={onChangeKycType}
                                      >
                                        <option value="">Select KYC Type</option>
                                        <option value="PASSPORT">PASSPORT</option>
                                        {/* <option value="DLN">DLN</option>
                                        <option value="GOVERNMENT_ISSUED_ID_CARD">GOVERNMENT_ISSUED_ID_CARD</option>
                                        <option value="HK_HKID">HK_HKID</option> */}
                                      </select>
                                      <span className={"help-block " + showKycTypeErr}>
                                        KYC Type is required!
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6" id="id_idNumber">
                                  <div className="form-group">
                                    <label>ID Number*</label>
                                    <div className="form-controls">
                                      <Input
                                        type="text"
                                        className="form-control no-icon"
                                        name="IdNumber"
                                        value={IdNumber}
                                        onChange={onChangeIdNumber}
                                        maxLength="50"
                                      />
                                      <span className={"help-block " + showIdNumberErr}>
                                        ID Number is required!
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6" id="id_idIssueDate">
                                  <div className="form-group">
                                    <label>ID Issue Date*</label>
                                    <div className="form-controls">
                                      <ReactDatePickerHelper
                                        datevalue={IdIssueDate}
                                        onchangedate={onChangeIdIssueDate}
                                        maximumdate={new Date()}
                                      />
                                      <span className="icon-calender _ico"></span>
                                      <span className="icon-round icon-calender-mini"></span>
                                      <span className={"help-block " + showIdIssueDateErr}>
                                        ID Issue Date is required!
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6" id="id_idExpDate">
                                  <div className="form-group">
                                    <label>ID Expiry Date*</label>
                                    <div className="form-controls">
                                      <ReactDatePickerHelper
                                        datevalue={IdExpDate}
                                        onchangedate={onChangeIdExpDate}
                                      />
                                      <span className="icon-calender _ico"></span>
                                      <span className="icon-round icon-calender-mini"></span>
                                      <span className={"help-block " + showIdExpDateErr}>
                                        ID Expiry Date is required!
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {IssuerCategory === "IssuerZD" && (
                                  <div className="col-md-6" id="spendinglimit_issuer12">
                                    <div className="form-group" >
                                      <label>Initial Load (min $1)*</label>
                                      <div className="form-controls">
                                        <Input
                                          type="number"
                                          className="form-control no-icon"
                                          name="spendinglimit"
                                          value={SpendingLimits}
                                          onChange={onChangeSpendingLimit}
                                          maxLength="10"
                                          min="1"
                                        />

                                        <span className={"help-block " + showSpendingLimitErr}>
                                          {spendingLimitErrMsg}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Fragment>
                            )
                          }
                          

                          {
                            ( IssuerCategory === "IssuerM" || IssuerCategory === "IssuerWex") && CheckcardVisaMaster === "Both" && cardCurrency === "USD" ? (
                              <div className="col-md-6" id="id_cardType">
                                <div className="form-group">
                                  <label>Network*</label>
                                  <div className="form-controls">
                                    <select
                                      onChange={onChangeCardVisaMaster}
                                      className="form-control no-icon"
                                    >
                                      <option select="selected" value={"Select"}>
                                        Select
                                      </option>
                                      <option select="selected" value={"Visa"}>
                                        Visa
                                      </option>
                                      <option select="selected" value={"Master"}>
                                          MC
                                        </option>
                                    </select>
                                    <span
                                      className={
                                        "help-block " + showCardCategoryErr
                                      }
                                    >
                                      Card Category Is Required!
                                    </span>
                                  </div>

                                </div>
                              </div>
                            )
                              : (IssuerCategory === "IssuerM") && cardCurrency === "USD" ? (
                                <div className="col-md-6" id="id_cardType">
                                  <div className="form-group">
                                    <label>Card Category*</label>
                                    <div className="form-controls"></div>
                                    <input
                                      type="text"
                                      value={CheckcardVisaMaster}
                                      disabled="disabled"
                                      className="form-controls"
                                    />
                                  </div>
                                </div>
                              ) : (<div id="id_cardType"></div>)
                          }
                         {
                           IssuerCategory === "IssuerM" ? (
                              <>
                                <div className="col-md-6" id="id_cardBin">
                                  <div className="form-group">
                                    <label>Card Bin*</label>
                                    <div className="form-controls">
                                      <select
                                        onChange={onChangeCardBin}
                                        className="form-control no-icon"
                                        // Auto-select first option based on card type

                                        defaultValue={

                                          CheckcardVisaMaster === "Visa" && (CardVisaMaster ?? "") !== "Master"
                                            ? "23"
                                            : CheckcardVisaMaster === "Master" && (CardVisaMaster ?? "") !== "Visa"
                                              ? "31"
                                              : "" // fallback if nothing matches
                                        }
                                      >
                                        {/* Visa Options */}
                                        {((CheckcardVisaMaster === "Visa" || CheckcardVisaMaster === "Both") &&
                                          (CardVisaMaster ?? "") !== "Master") && (
                                            <>
                                            <option value="">Select</option>
                                              <option value="23">428803</option>
                                              <option value="25">401994</option>

                                            </>
                                          )}

                                        {/* Master Options */}
                                        {((CheckcardVisaMaster === "Master" || CheckcardVisaMaster === "Both") &&
                                          (CardVisaMaster ?? "") !== "Visa") && (
                                            <>
                                            <option value="">Select</option>
                                              <option value="31">539186</option>
                                            </>
                                          )}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : IssuerCategory === "IssuerX" ? (<>
                              <div className="col-md-6" id="id_cardBin">
                                <div className="form-group">
                                  <label>Card Bin*</label>
                                  <div className="form-controls">
                                    <select
                                      onChange={onChangeCardBin}
                                      className="form-control no-icon"
                                      defaultValue="556371"
                                    >
                                      <>
                                      <option value="">Select</option>
                                        <option value="556371">556371</option>
                                        <option value="534786">534786</option>
                                        <option value="531993">531993</option>
                                        <option value="553437">553437</option>
                                        <option value="404038">404038</option>
                                        <option value="489683">489683</option>
                                        <option value="441112000">441112000</option>
                                        <option value="43345100">43345100</option>
                                        <option value="559292">559292</option>
                                        <option value="519075">519075</option>
                                        <option value="556150">556150</option>
                                        <option value="52489756">52489756</option>
                                        <option value="52489710">52489710</option>
                                        <option value="52489753">52489753</option>
                                        <option value="55323105">55323105</option>
                                        <option value="55337000">55337000</option>
                                        <option value="44742000">44742000</option>
                                        <option value="49109000">49109000</option>
                                        <option value="48960700">48960700</option>
                                        <option value="48331700">48331700</option>
                                        <option value="47671500">47671500</option>
                                        <option value="42883600">42883600</option>
                                        <option value="440872">440872</option>
                                        <option value="485997">485997</option>
                                        <option value="55616764">55616764</option>
                                        <option value="55616702">55616702</option>
                                        <option value="55616731">55616731</option>
                                        <option value="52489792">52489792</option>
                                        <option value="55323173">55323173</option>
                                        <option value="55616729">55616729</option>
                                        <option value="55616741">55616741</option>
                                        <option value="553301032">553301032</option>
                                        <option value="553301034">553301034</option>
                                        <option value="553301036">553301036</option>
                                        <option value="553301038">553301038</option>
                                        <option value="556167230">556167230</option>
                                        <option value="556167232">556167232</option>
                                        <option value="556167234">556167234</option>
                                        <option value="556167236">556167236</option>
                                        <option value="554866">554866</option>
                                        <option value="42460511">42460511</option>
                                        <option value="43612033">43612033</option>
                                        <option value="44661359">44661359</option>
                                        <option value="44325235">44325235</option>
                                        <option value="53602586">53602586</option>
                                        <option value="53602505">53602505</option>
                                        <option value="53602595">53602595</option>
                                        <option value="53602597">53602597</option>
                                        <option value="53602591">53602591</option>
                                        <option value="53602544">53602544</option>
                                        <option value="53602524">53602524</option>
                                        <option value="53602570">53602570</option>
                                        <option value="53602523">53602523</option>
                                        <option value="53602560">53602560</option>
                                        <option value="536025898">536025898</option>
                                        <option value="536025662">536025662</option>
                                        <option value="536025664">536025664</option>
                                        <option value="536025666">536025666</option>
                                        <option value="536025668">536025668</option>
                                        <option value="536025890">536025890</option>
                                        <option value="536025892">536025892</option>
                                        <option value="536025894">536025894</option>
                                        <option value="536025896">536025896</option>
                                        <option value="53602584">53602584</option>
                                        <option value="53602563">53602563</option>
                                        <option value="53602567">53602567</option>
                                        <option value="53602553">53602553</option>
                                        <option value="52489729">52489729</option>
                                        <option value="556167238">556167238</option>
                                        <option value="55616701">55616701</option>
                                      </>
                                    </select>
                                  </div>
                                </div>
                              </div>

                            </>) : (<>
                              <div id="id_cardBin"></div>
                            </>)
                          }
                          {
                            ((IssuerCategory === "Issuer12"||IssuerCategory=="OB-OF")) && (
                              <div className="col-md-6" id="spendinglimit_issuer12">
                                <div className="form-group" >
                                  <label>Initial Load (min $20)*</label>
                                  <div className="form-controls">
                                    <Input
                                      type="number"
                                      className="form-control no-icon"
                                      name="spendinglimit"
                                      value={SpendingLimits}
                                      onChange={onChangeSpendingLimit}
                                      maxLength="10"
                                      min="20"
                                    />
                                    
                                    <span className={"help-block " + showSpendingLimitErr}>
                                      {spendingLimitErrMsg}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          {
                            ((IssuerCategory === "OB-FIT"|| IssuerCategory === "OB-TIX")) && (
                              <div className="col-md-6" id="spendinglimit_issuer12">
                                <div className="form-group" >
                                  <label>Initial Load (min $1)*</label>
                                  <div className="form-controls">
                                    <Input
                                      type="number"
                                      className="form-control no-icon"
                                      name="spendinglimit"
                                      value={SpendingLimits}
                                      onChange={onChangeSpendingLimit}
                                      maxLength="10"
                                      min="20"
                                    />
                                    
                                    <span className={"help-block " + showSpendingLimitErr}>
                                      {spendingLimitErrMsg}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          {
                            IssuerCategory === "IssuerM" &&(
                              <div className="col-md-6" id="id_cardBin">
                                <div className="form-group">
                                  <label>Spend Control Limit*</label>
                                  <div className="form-controls">
                                    <select
                                      onChange={onChangeSpendingLimitM}
                                      className="form-control no-icon"
                                      defaultValue="1000000"
                                    >
                                      <>
                                        <option value="500000">5000</option>
                                        <option value="1000000">10000</option>
                                        <option value="1500000">15000</option>
                                        <option value="2000000">20000</option>
                                        <option value="2500000">25000</option>
                                        <option value="3000000">30000</option>
                                        <option value="3500000">35000</option>
                                        <option value="4000000">40000</option>
                                        <option value="4500000">45000</option>
                                        <option value="5000000">50000</option>
                                      </>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          
                                                    
                          {
                            IssuerCategory === "IssuerG" ?(<>
                                    <div className="col-md-6">
                                        <div className="form-group" id="card_holder_profession">
                                          <label>Card Holder Profession*</label>
                                          <div className="form-controls">
                                            <Input
                                              type="text"
                                              className="form-control no-icon"
                                              name="LastName"
                                              value={cardholderProfession}
                                              onChange={onChangeCardholderProfession}
                                              validations={[cardHolderProfessionRequired]}
                                              maxLength="50"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group" id="card_holder_occupation">
                                          <label>Card Holder Occupation*</label>
                                          <div className="form-controls">
                                            <Input
                                              type="text"
                                              className="form-control no-icon"
                                              name="LastName"
                                              value={cardholderOccupation}
                                              onChange={onChangeCardholderOccupation}
                                              validations={[cardHolderOccupationRequired]}
                                              maxLength="50"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group" id="card_holder_employer_name">
                                          <label>Card Holder Employer Name*</label>
                                          <div className="form-controls">
                                            <Input
                                              type="text"
                                              className="form-control no-icon"
                                              name="LastName"
                                              value={cardholderEmployername}
                                              onChange={onChangeCardholderEmployername}
                                              validations={[cardHolderEmployerRequired]}
                                              maxLength="50"
                                            />
                                          </div>
                                        </div>
                                      </div>
                            </>):( <Fragment>
                              <div id="card_holder_profession"></div>
                              <div id="card_holder_occupation"></div>
                              <div id="card_holder_employer_name"></div>
                            </Fragment>)
                          }
                            {IssuerCategory === "IssuerG" ? (
                            <Fragment>
                              <div className="col-md-6" id="cardcolor">
                                <div className="form-group">
                                  <label>Card Color*</label>
                                  <div className="form-controls">
                                    <select
                                      onChange={onChangeCardColor}
                                      className="form-control no-icon"
                                      id="delivery_mode"

                                    >
                                      <option value="">Select Card Color</option>
                                      <option select="selected" value='Green'>
                                        Green
                                      </option>
                                      <option value='Silver'>
                                        Black
                                      </option>

                                    </select>
                                    <span
                                      className={
                                        "help-block " + showCardColorErr
                                      }
                                    >
                                      Card Color is required!
                                    </span>

                                  </div>
                                </div>
                              </div>
                            </Fragment>
                          ) : (<Fragment><div id="cardcolor"></div></Fragment>)}
                           
                          <div className="col-md-12">
                            <div className="form-group submit-field d-flex justify-content-end mt-20 mb-0">
                              <a
                                className="btn btn-outline mr-19"
                                data-bs-dismiss="modal"
                                onClick={props.onHide}
                              >
                                Cancel
                              </a>
                              <a className="btn btn-large" onClick={IssueCardHolderHandler}>
                                Issue Card
                              </a>
                            </div>
                          </div>
                        </div>
                        <CheckButton
                          style={{ display: "none" }}
                          ref={checkBtn}
                        />
                      </Form>
                    </div>
                  </div>
                  <div
                    className={cardContentClassName}
                    id="cardDetails"
                    role="tabpanel"
                    aria-labelledby="cardDetails-tab"
                  >
                    <div className="row row-card-details-popup">
                      <div className="col-md-12">
                        <ul className="ul-card-details-popup ul-issue-card">
                          <li className="mb-20">
                            <div className="row">
                              <div className="col-4">
                                <label>Name</label>
                              </div>
                              <div className="col-8">
                                <span>{FirstName + "   " + LastName}</span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-20">
                            <div className="row">
                              <div className="col-4">
                                <label>Email</label>
                              </div>
                              <div className="col-8">
                                <span>{Email}</span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-20">
                            <div className="row">
                              <div className="col-4">
                                <label>Phone Number</label>
                              </div>
                              <div className="col-8">
                                <span>{phoneNumber}</span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-20">
                            <div className="row">
                              <div className="col-4">
                                <label>Date of Birth</label>
                              </div>
                              <div className="col-8">
                                <span>
                                  <DateFormat date={dob} />
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-20">
                            <div className="row">
                              <div className="col-4">
                                <label>Available Balance</label>
                              </div>
                              <div className="col-8">
                                <span>$ 0</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group submit-field d-flex justify-content-end mt-20 mb-0">
                          <button
                            className="btn btn-large"
                            data-bs-dismiss="modal"
                            onClick={IssueCardDoneHandler}
                            disabled={disableBtns}
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialoguePopup
        show={modalShow}
        onHide={() => setModalShow(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
        hideallpopups={props.onHide}
      />
    </Fragment>
  );
};
export default IssueCardBody;
